import CloseIcon from "@mui/icons-material/Close";
import { Box, Collapse, IconButton, Typography } from "@mui/material";
import { useState } from "react";

const EnvironmentBanner = () => {
  const [isVisible, setIsVisible] = useState(true);

  if (process.env.REACT_APP_ENV === "prod" || !isVisible) {
    return null;
  }

  const getBannerColor = () => {
    switch (process.env.REACT_APP_ENV) {
      case "preprod":
        return {
          displayText: "Demo Environment",
          bg: "red",
          text: "white",
        };
      default:
        return {
          displayText: `Development - ${process.env.REACT_APP_ENV}`,
          bg: "yellow",
          text: "black",
        };
    }
  };

  const { bg, text, displayText } = getBannerColor();

  return (
    <Collapse in={isVisible}>
      <Box
        sx={{
          backgroundColor: bg,
          color: text,
          display: "flex",
          alignItems: "center",
          padding: "2px 0",
          position: "relative",
        }}>
        {/* Spacer for left alignment symmetry */}
        <Box sx={{ width: 30 }} />

        <Box sx={{ flex: 1, textAlign: "center" }}>
          <Typography variant="body1">{displayText}</Typography>
        </Box>

        <IconButton
          onClick={() => setIsVisible(false)}
          sx={{
            position: "absolute",
            right: 8,
            color: text,
          }}>
          <CloseIcon />
        </IconButton>
      </Box>
    </Collapse>
  );
};

export default EnvironmentBanner;
